import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import MarketingLayout from "@/components/MarketingLayout";
import Home from "@/pages/Home";
import Team from "@/pages/Team";
import Products from "@/pages/Products";
import AstroRemedies from "@/pages/AstroRemedies";
import Workshops from "@/pages/Workshops";
import Testimonials from "@/pages/Testimonials";
import Meditations from "@/pages/Meditations";
import Contact from "@/pages/Contact";
import BookAppointment from "@/pages/BookAppointment";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Scan from "@/pages/Scan";
import AstroScan from "@/pages/AstroScan";
import ReportPage from "@/pages/ReportPage";
import Admin from "@/pages/Admin";
import AdminSettings from "@/pages/AdminSettings";
import ProductDetail from "@/pages/ProductDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Purchases from "@/pages/Purchases";
import PaymentCancel from "@/pages/PaymentCancel";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Refund from "@/pages/Refund";
import Disclaimer from "@/pages/Disclaimer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<MarketingLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/team" element={<Team />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/remedies" element={<AstroRemedies />} />
            <Route path="/workshops" element={<Workshops />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/meditations" element={<Meditations />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book" element={<BookAppointment />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/app/scan" element={<ProtectedRoute><Scan /></ProtectedRoute>} />
          <Route path="/app/astro" element={<ProtectedRoute><AstroScan /></ProtectedRoute>} />
          <Route path="/app/purchases" element={<ProtectedRoute><Purchases /></ProtectedRoute>} />
          <Route path="/app/reports/:id" element={<ProtectedRoute><ReportPage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;